export class EntryDictionary {

  static Exam = {
    aCT: '1Ppu5u1cmIeuGuYskCMIkW'
  };

  static Subject = {
    english: '37ItV90Gda8KmuYwmEoCAg',
    math: '5EUxJOh0vCYQ6KuYOGCM8E',
    reading: '45S5immZ7imcyAA42wAq84',
    science: '7lCssd4Unucuqy0Iio2mSy'
  };

  static Topic = {
    adjective: '11DCB0sUG4wKcmgag4G2gC',
    adverb: '42qoBgLh9emIcwucCcOCOq',
    apostrophe: 'tm04qhWRe8yyaqiAUGCo2',
    appositive: '1xKedVrX1iAaSUOoQgsa2k',
    clause: '1w2P8UFfCQUyu0ueSak4yk',
    colon: '1fedflAoe4MSYcKIYEwe20',
    comma: '21cHJwJI5mGoIEsiKQuOEq',
    dash: '2AzR0MaveEKIis2gWAI6um',
    fragment: '5Ds70Sm0XSuUAkioOswqAq',
    gerund: '5W1SPnCis0uGeiUo4ysCKE',
    independentClause: '2bLdJ3iiDega8AmwqieKMO',
    participialPhrase: '4KiGXzEp5mW2EwEQEYMGGg',
    participle: '37j6X2J600CwucWcgsgKcQ',
    period: '54iaoHbz8Q8AoQGkQIeug6',
    phrasevsClause: 'f8KRjd0XAcmacUy8OQkEI',
    preposition: '2B9qqfpBfKkuCICoYWKoMi',
    prepositionalPhrase: '6qwPQw51UQYEkukYKS8486',
    runOn: '3DP2TiibYQEq0O4AoMQoQq',
    semicolon: '1TpEMF7792aISUGcuQYYi2',
    subjectPronounsvsObjectPronouns: '7yoTz46kGk0qycksI2EEKu',
    subjectvsObject: '4FcFU2Qvvis8s4Si08OkUe',
    subordinateClause: '2ESdVlLJrCQyuQYsa8IY2W',
    testTopicMath: '1hVd7BDSlKEOycGkYyYEOe',
    testTopicMath2: '34foOA6hpCcgo0MeAwwK4U',
    testTopicReading: '3rpTkNyYkUWaWagA0Gqo24',
    testTopicReading2: '1yqO2x7hqwcsUQI8imwsOm',
    testTopicScience: '5bzZcYnwZGGMmemYwwwAmm',
    testTopicScience2: '1vo8NgIIcca8cEyIua2gI2',
    thanvsThen: '3g3JdGoYacmQgyca6iAIOw',
    verb: '60MoDhFLRmE8CYSO6OiKkK',
    whovsWhom: 'Gfhg4JupIiYeQqqayQeGC'
  };

}

